import { mood } from './support'

export const publishData = (tenantId: string, tenantName: string, folderId: string, folderName: string) => {
  return mood.postJson(`Service/UploadFweData`, {tenantId, tenantName, folderId, folderName}, "1")
}
